import { FileText } from "lucide-react";
import { Main } from "@/components/Main";
import { PageHeader } from "@/components/PageHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { CompressPdf } from "@/App/PdfTools/CompressPdf";
import { JpgToPdf } from "@/App/PdfTools/JpgToPdf";

/**
 * Ferramentas de PDF (LOT-60): comprimir um PDF e criar um PDF a partir de imagens JPG.
 * Os arquivos são processados na API e não ficam guardados.
 */
export const PageList = () => (
  <Main>
    <PageHeader
      icon={FileText}
      title="Ferramentas de PDF"
      description="Comprima PDFs e crie PDFs a partir de imagens JPG"
    />

    <Tabs defaultValue="compress" className="space-y-4">
      <TabsList>
        <TabsTrigger value="compress">Comprimir PDF</TabsTrigger>
        <TabsTrigger value="jpg-to-pdf">JPG para PDF</TabsTrigger>
      </TabsList>
      <TabsContent value="compress">
        <CompressPdf />
      </TabsContent>
      <TabsContent value="jpg-to-pdf">
        <JpgToPdf />
      </TabsContent>
    </Tabs>
  </Main>
);
